module.exports = __webpack_public_path__ + "static/media/notFoundImage.dbae6ccc.png";